import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Search, Bell, Settings, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext.tsx';
import './Navbar.css';

interface NavbarProps {
  isCollapsed: boolean;
  toggleSidebar: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ isCollapsed, toggleSidebar }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const userName = user?.username || 'Admin User';
  const userRole = user?.role_name || 'Super Admin';
  const userInitial = userName.charAt(0).toUpperCase();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className={`navbar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="navbar-left">
        <button className="navbar-toggle" onClick={toggleSidebar}>
          <Menu size={20} />
        </button>
        
        <div className="navbar-search">
          <Search size={18} />
          <input type="text" placeholder="Search..." />
        </div>
      </div>

      <div className="navbar-right">
        <button className="navbar-icon-btn">
          <Bell size={20} />
          <span className="badge"></span>
        </button>

        <button className="navbar-icon-btn">
          <Settings size={20} />
        </button>

        <div className="navbar-divider"></div>

        <div className="navbar-user">
          <div className="navbar-user-info">
            <p className="navbar-user-name">{userName}</p>
            <p className="navbar-user-role">{userRole}</p>
          </div>
          <div className="navbar-user-avatar">{userInitial}</div>
        </div>

        <button className="navbar-logout" onClick={handleLogout}>
          <LogOut size={16} />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
